export default [
	{
		path: '/app/fileset',
		component: () => import('../../../layouts/MainLayout.vue'), // 使用するレイアウトの選択
		children: [
			{
				path: 'sendInfo/:filesetId', // 親と同じpathで表示するコンポーネントを下記で指定
				name: 'filesetSendInfo',
				component: () => import('../../../components/fileset/SendInfoView'),
				meta: { title:'YubiOn SecureFileTransfer | Sent file information'}
			},
			{
				path: 'receiveInfo/:filesetId', // 親と同じpathで表示するコンポーネントを下記で指定
				name: 'filesetReceiveInfo',
				component: () => import('../../../components/fileset/ReceiveInfoView'),
				meta: { title:'YubiOn SecureFileTransfer | Received file information'}
			},
			{
				path: 'sendList',
				name: 'filesetSendList',
				component: () => import('../../../components/fileset/SendListView'),
				meta: { title:'YubiOn SecureFileTransfer | Outbox'}
			},
			{
				path: 'receiveList',
				name: 'filesetReceiveList',
				component: () => import('../../../components/fileset/ReceiveListView'),
				meta: { title:'YubiOn SecureFileTransfer | Inbox'}
			},
			{
				path: 'upload',
				name: 'filesetUpload',
				component: () => import('../../../components/fileset/UploadView'),
				meta: { title:'YubiOn SecureFileTransfer | Upload'}
			},
		]
	},
	{
		//権限無しで閲覧可能なファイルセット
		//receiveInfo内で
		//・ファイル送信先が制限なし
		//・ログインしていない
		//の状態の時に一度こちらに遷移する。
		path: '/app/filesetNoAuth',	
		component: () => import('../../../layouts/UnauthLayout.vue'), // 使用するレイアウトの選択
		children: [
			{
				path: 'receiveInfo/:filesetId', // 親と同じpathで表示するコンポーネントを下記で指定
				name: 'filesetReceiveInfoNoAuth',
				component: () => import('../../../components/fileset/ReceiveInfoView'),
				meta: { title:'YubiOn SecureFileTransfer | Received file information'}
			},
		]
	}
]
